import * as _4 from 'lodash4';
class PlanFeedbackRevokePopup {
  constructor(private $state: any) {}
  clickedGotoMyPlan() {
    this.$state.go('my.planner.plan.default');
  }
}

angular.module('capability-ng-academic-planner').component('planFeedbackRevokedPopup', {
  templateUrl:
    'capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_revoked_popup/plan_feedback_revoked_popup.html',
  controller: PlanFeedbackRevokePopup
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_revoked_popup/plan_feedback_revoked_popup.ts